import { Chats as ChatsIcon } from '@phosphor-icons/react';

interface ActionButtonIconProps {
  iconKey: string;
}

function ActionButtonIcon({ iconKey }: ActionButtonIconProps) {
  const Icon = getIcon(iconKey);

  function getIcon(iconKey: string) {
    switch (iconKey) {
      case 'chats':
        return ChatsIcon;
      default:
        return null;
    }
  }

  if (!Icon) {
    return null;
  }

  return <Icon size={24} weight="duotone" />;
}

export default ActionButtonIcon;
